import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getAlarms, postAlarmRead, postAlarmReadOne, deleteAlarms } from '@entities/notification'
import { useAuthStore } from '@features/auth'

export const useAlarmList = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const isLoggedIn = useAuthStore(s => s.isLoggedIn)

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['alarm', 'list'],
    queryFn: () => getAlarms(),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    enabled: isLoggedIn && enabled,
  })

  return {
    alarms: data?.alarms ?? [],
    isLoading,
    refetch,
  }
}

export const useReadAllAlarms = () => {
  const queryClient = useQueryClient()

  const { mutate: readAllAlarms, isPending } = useMutation({
    mutationFn: postAlarmRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['alarm', 'list'] })
    },
  })

  return { readAllAlarms, isPending }
}

export const useReadOneAlarm = () => {
  const queryClient = useQueryClient()

  const { mutate: readOneAlarm, isPending } = useMutation({
    mutationFn: (alarmId: number) => postAlarmReadOne(alarmId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['alarm', 'list'] })
    },
  })

  return { readOneAlarm, isPending }
}

export const useDeleteAllAlarms = () => {
  const queryClient = useQueryClient()

  const { mutate: deleteAllAlarms, isPending } = useMutation({
    mutationFn: deleteAlarms,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['alarm', 'list'] })
    },
  })

  return { deleteAllAlarms, isPending }
}
